'use client';

import { removeCookie } from '@/utils/helpers/cookies';
import { ReactNode, useEffect, useState } from 'react';
import { ErrorBoundary as ErrorBoundaryHandler } from 'react-error-boundary';
import { ErrorFallback } from './ErrorFallback';

interface ErrorProps {
	children: ReactNode;
}

const ErrorBoundary = ({ children }: ErrorProps) => {
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		if (hasError) {
			removeCookie();
			window.location.href = `/auth/login`;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasError]);
	// console.log('error');
	return (
		<ErrorBoundaryHandler
			FallbackComponent={ErrorFallback}
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			onReset={() => {}}
			onError={(error, errorInfo) => {
				console.error('Uncaught error:', error, errorInfo);
				setHasError(true);
			}}
		>
			{children}
		</ErrorBoundaryHandler>
	);
};

export default ErrorBoundary;
